import {Team} from '@/user/user.interface';
import {useNavigate} from 'react-router-dom';
import EditIcon from '../../assets/img/icons/edit-icon-minimal.svg?react';

export const TeamProfile = ({teamInfo, role}: {teamInfo: Team | undefined; role: string}) => {
  const navigate = useNavigate();

  if (!teamInfo) {
    return null;
  }
  const teamName = teamInfo?.teamName;
  const profileBarBackgroundColor = teamInfo?.teamColor || 'var(--theme-primary)';

  const onClickEditTeam = () => {
    navigate(`/${role}/teams/${teamInfo?._id}/edit`);
  };

  return (
    <div
      className="exceed-global-padding pt-3 pb-3 pr-5 pl-5 grid grid-cols-[auto_1fr] gap-5"
      style={{backgroundColor: profileBarBackgroundColor}}
    >
      {/* <img src={teamInfo.logoUrl} alt={`${teamName} logo`} className="h-14 w-14 min-w-14 object-cover rounded-md" /> */}
      <div className="min-w-0 flex flex-col justify-center space-y-3">
        <p className="text-white font-semibold text-lg leading-lg flex items-center">
          {teamName}
          <EditIcon
            className="fill-white h-3 w-3 ml-2 cursor-pointer"
            data-test-id="edit-team"
            onClick={onClickEditTeam}
          />
        </p>
      </div>
    </div>
  );
};
